import { Intent, Position, Toast, Toaster } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import * as React from 'react';

import { useAppDispatch, useAppSelector } from 'src/ui/app/hooks';
import {
  ActionableNotificationMessage,
  NotificationAction,
} from 'src/ui/components/ActionableNotificationMessage';
import {
  NotificationButtonAction,
  unqueueNotification,
} from 'src/ui/features/notifications';
import { showVerifyEmailDialog } from 'src/ui/features/ui';

// Component to handle showing and closing "snackbar" notifications. The
// component renders only one notification (the first one in the notifications
// queue) at a time.
export const Notifications: React.VFC = () => {
  const notifications = useAppSelector(
    (state) => state.notifications.notifications
  );
  const dispatch = useAppDispatch();

  const onVerifyEmail = () => dispatch(showVerifyEmailDialog());

  const onUnqueueNotification = (id: string) =>
    dispatch(unqueueNotification(id));

  const getActionForButton = (
    button?: NotificationButtonAction
  ): NotificationAction | undefined => {
    if (button === 'Verify Email') {
      return {
        text: button,
        onClick: onVerifyEmail,
      };
    }

    return undefined;
  };

  return (
    <Toaster position={Position.BOTTOM_RIGHT}>
      {notifications.map(({ message, button }) => {
        let messageElement: React.ReactNode = message;

        const action = getActionForButton(button);
        if (action) {
          messageElement = (
            <ActionableNotificationMessage
              message={message}
              actions={[action]}
            />
          );
        }

        return (
          <Toast
            key={message}
            timeout={15000}
            onDismiss={() => onUnqueueNotification(message)}
            message={messageElement}
            icon={IconNames.WARNING_SIGN}
            intent={Intent.DANGER}
            data-testid="toast"
          />
        );
      })}
    </Toaster>
  );
};
